import { Remarkable } from 'remarkable';
import remarkableExternalLink from 'remarkable-external-link'; // This values are default

var md = new Remarkable('full', {
  html: true
});
md.use(remarkableExternalLink, {
  hosts: []
});
export var mdRender = function mdRender(content) {
  // content.replace('<br />', '\n');
  return md.render(content);
};